import { Configuration, ApiConfigOptions } from '@sg/api/base-api-lib';

export interface CurrenciesApiConfigOptions extends ApiConfigOptions {}
export class CurrenciesApiConfig extends Configuration {
  constructor(configOptions?: CurrenciesApiConfigOptions) {
    super({ ...{}, ...(configOptions || {}) });
  }
}
